import { FC, useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal } from 'antd';
import useAxios from "../../../../hooks/useAxios";
import Loader from "../../../Loader";
import ErrorResponse from "../../../ErrorResponse";
import { createNotification } from "../../../../api/notification.api";
import useNotification from "../../../../hooks/useNotification";
//import NoticeEditor2 from "../NoticeEditor2";
import NoticeMultiCase from "../NoticeMultiCase";
import NoticeConfirmModal from "../NoticeConfirmModal";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  event: any;
  doGetClassNotice: () => void;
  isTutor?: boolean;
  className?: string|undefined;
}

const CreateNoticeModal2: FC<IProps> = ({
  visible,
  setVisible,
  event,
  doGetClassNotice,
  isTutor = false,
  className,
}) => {
  const { t } = useTranslation();
  const { successNotification } = useNotification();
  //const { data: res, isLoading, error, execute } = useAxios();
  const [isLoading, setIsLoading] = useState<boolean>();
  const [toSubmit, setToSubmit] = useState(false);
  const [confirmSubmitVisible, setConfirmSubmitVisible] = useState(false);
  const [confirmText, setConfirmText] = useState<string>('');
  const [confirmTitle, setConfirmTitle] = useState<string>('');
  
  /*
  useEffect(() => {
    if (res && !isLoading) {
      doGetClassNotice();
      successNotification(t('common.message.save1'));
      setVisible(false);
    }
  }, [res, isLoading]);

  const submit = (data: FormData) => {
    execute(createNotification(data));
  }
  */

  const readySubmit = () => {
    setToSubmit(true);
    setConfirmSubmitVisible(false);
  }

  const completeSubmit = (isAllComplete : boolean) => {
    doGetClassNotice();
    if(isAllComplete) {
      successNotification(t('common.message.save1'));
      setVisible(false);
    }
  }

  return (
    <>
      { isLoading ? <Loader /> : null }
      {/*<ErrorResponse error={error} />*/}

      <Modal
        title={t('class.class.title14')}
        visible={visible}
        width={750}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={() => {
                //setToSubmit(true);
                setConfirmSubmitVisible(true);
              }}
            >
              {t('common.button.save')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setVisible(false)}
            >
              {t('common.button.close')}
            </AntButton>
          </div>
        ]}
      >
        <NoticeMultiCase
          event={event}
          completeSubmit={completeSubmit}
          toSubmit={toSubmit}
          setToSubmit={setToSubmit}
          isTutor={isTutor}
          className={className}
          setIsLoading={setIsLoading}
          setConfirmText={setConfirmText}
          setConfirmTitle={setConfirmTitle}
        />
      </Modal>

      <NoticeConfirmModal
        visible={confirmSubmitVisible}
        setVisible={setConfirmSubmitVisible}
        onConfirm={readySubmit}
        titleText={confirmTitle}
        messageText={confirmText}
        confirmText={t('common.button.save')}
        cancelText={t('common.button.cancel')}
        className={'flex justify-content-center'}
      />
    </>
  );
}

export default CreateNoticeModal2;
